import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0B]" data-testid="route-loading">
      <Loader2 className="w-8 h-8 text-[#E53E3E] animate-spin" />
    </div>
  );
}

const dashboardFor = (role) => {
  if (role === "member") return "/dashboard/member";
  if (role === "partner") return "/dashboard/partner";
  if (role === "admin" || role === "super_admin") return "/admin";
  return "/";
};

export function ProtectedRoute({ children, allowedRoles, redirectTo = "/login" }) {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (user === false) return <Navigate to={redirectTo} replace />;
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={dashboardFor(user.role)} replace />;
  }
  return children;
}

export { FullScreenLoader, dashboardFor };
